/* eslint-disable max-lines */

import { Route } from '@angular/router';

import { provideTemplateDefinition } from './app/providers/template-definition.provider';
import {
  AccountRecoveryRequestStartedTemplateComponent,
  AccountRecoveryRequestStartedTemplateMocks,
} from './app/templates/account-recovery-request-started/account-recovery-request-started.component';
import {
  AccountRecoveryRequestUrlTemplateComponent,
  AccountRecoveryRequestUrlTemplateMocks,
} from './app/templates/account-recovery-request-url/account-recovery-request-url.component';
import {
  AdminDeletedTemplateComponent,
  AdminDeletedTemplateMocks,
} from './app/templates/admin-deleted/admin-deleted.component';
import {
  AdminDeletionRequestCreatedTemplateComponent,
  AdminDeletionRequestCreatedTemplateMocks,
} from './app/templates/admin-deletion-request-created/admin-deletion-request-created.component';
import {
  AdminDeletionScheduledTemplateComponent,
  AdminDeletionScheduledTemplateMocks,
} from './app/templates/admin-deletion-scheduled/admin-deletion-scheduled.component';
import {
  AfterSubscriptionDowngradeTemplateComponent,
  AfterSubscriptionDowngradeTemplateMocks,
} from './app/templates/after-subscription-downgrade/after-subscription-downgrade.component';
import {
  BeforeSubscriptionDowngradeTemplateComponent,
  BeforeSubscriptionDowngradeTemplateMocks,
} from './app/templates/before-subscription-downgrade/before-subscription-downgrade.component';
import {
  BrokenSyncAlertTemplateComponent,
  BrokenSyncAlertTemplateMocks,
} from './app/templates/broken-sync-alert/broken-sync-alert.component';
import {
  CandidateSharedTemplateComponent,
  CandidateSharedTemplateMocks,
} from './app/templates/candidate-shared/candidate-shared.component';
import {
  CompanyDeletedTemplateComponent,
  CompanyDeletedTemplateMocks,
} from './app/templates/company-deleted/company-deleted.component';
import {
  CompanyDeletionRequestCreatedTemplateComponent,
  CompanyDeletionRequestCreatedTemplateMocks,
} from './app/templates/company-deletion-request-created/company-deletion-request-created.component';
import { CompanyDeletionScheduledTemplateMocks } from './app/templates/company-deletion-scheduled/company-deletion-scheduled.component';
import {
  CompanyVerificationRequestTemplateComponent,
  CompanyVerificationRequestTemplateMocks,
} from './app/templates/company-verification-request/company-verification-request.component';
import {
  CompleteAccountSetupTemplateComponent,
  CompleteAccountSetupTemplateMocks,
} from './app/templates/complete-account-setup/complete-account-setup.component';
import { DemoTemplateComponent, DemoTemplateMocks } from './app/templates/demo/demo.component';
import {
  EeoDataRequestTemplateComponent,
  EeoDataRequestTemplateMocks,
} from './app/templates/eeo-data-request/eeo-data-request.component';
import {
  EmailChangeStartProcessTemplateComponent,
  EmailChangeStartProcessTemplateMocks,
} from './app/templates/email-change-start-process/email-change-start-process.component';
import {
  EmailChangeVerificationTemplateComponent,
  EmailChangeVerificationTemplateMocks,
} from './app/templates/email-change-verification/email-change-verification.component';
import {
  EventNotificationTemplateComponent,
  EventNotificationTemplateMocks,
} from './app/templates/event-notification/event-notification.component';
import {
  FeatureRequestCreatedTemplateComponent,
  FeatureRequestCreatedTemplateMocks,
} from './app/templates/feature_request_created/feature_request_created.component';
import {
  GdprAutoConsentTemplateComponent,
  GdprAutoConsentTemplateMocks,
} from './app/templates/gdpr-auto-consent/gdpr-auto-consent.component';
import {
  GdprReportTemplateComponent,
  GdprReportTemplateMocks,
} from './app/templates/gdpr-report/gdpr-report.component';
import {
  InactiveAdminDeletedTemplateComponent,
  InactiveAdminDeletedTemplateMocks,
} from './app/templates/inactive-admin-deleted/inactive-admin-deleted.component';
import { InactiveCompanyDeletedTemplateMocks } from './app/templates/inactive-company-deleted/inactive-company-deleted.component';
import {
  JoinCompanyTemplateComponent,
  JoinCompanyTemplateMocks,
} from './app/templates/join-company/join-company.component';
import {
  MultipleNotificationsTemplateComponent,
  MultipleNotificationsTemplateMocks,
} from './app/templates/multiple-notifications/multiple-notifications.component';
import {
  NewCandidateTemplateComponent,
  NewCandidateTemplateMocks,
} from './app/templates/new-candidate/new-candidate.component';
import {
  NewCandidatesReportTemplateComponent,
  NewCandidatesReportTemplateMocks,
} from './app/templates/new-candidates-report/new-candidates-report.component';
import {
  NotificationMentionTemplateComponent,
  NotificationMentionTemplateMocks,
} from './app/templates/notification-mention/notification-mention.component';
import {
  ReferralApplicationConfirmationTemplateComponent,
  ReferralApplicationConfirmationTemplateMocks,
} from './app/templates/referral-application-confirmation/referral-application-confirmation.component';
import {
  ReferralEmailConfirmationTemplateComponent,
  ReferralEmailConfirmationTemplateMocks,
} from './app/templates/referral-email-confirmation/referral-email-confirmation.component';
import {
  ReferralSendInvitationTemplateComponent,
  ReferralSendInvitationTemplateMocks,
} from './app/templates/referral-send-invitation/referral-send-invitation.component';
import {
  RequisitionsApprovalRequestTemplateComponent,
  RequisitionsApprovalRequestTemplateMocks,
} from './app/templates/requisitions-approval-request/requisitions-approval-request.component';
import {
  ResetPasswordTemplateComponent,
  ResetPasswordTemplateMocks,
} from './app/templates/reset-password/reset-password.component';
import {
  ShareContainerTemplateComponent,
  ShareContainerTemplateMocks,
} from './app/templates/share-container/share-container.component';
import {
  SignInDetectedTemplateComponent,
  SignInDetectedTemplateMocks,
} from './app/templates/sign-in-detected/sign-in-detected.component';
import {
  SignUpVerificationReminderTemplateComponent,
  SignUpVerificationReminderTemplateMocks,
} from './app/templates/sign-up-verification-reminder/sign-up-verification-reminder.component';
import {
  SingleNotificationTemplateComponent,
  SingleNotificationTemplateMocks,
} from './app/templates/single-notification/single-notification.component';
import {
  SlotsUpgradedTemplateComponent,
  SlotsUpgradedTemplateMocks,
} from './app/templates/slots-upgraded/slots-upgraded.component';
import {
  SsoEnabledTemplateComponent,
  SsoEnabledTemplateMocks,
} from './app/templates/sso-enabled/sso-enabled.component';
import {
  SystemChangedVideoProviderTemplateComponent,
  SystemChangedVideoProviderTemplateMocks,
} from './app/templates/system-changed-video-provider/system-changed-video-provider.component';
import {
  TextingCampaignRequestNotificationTemplateComponent,
  TextingCampaignRequestNotificationTemplateMocks,
} from './app/templates/texting-campaign-request-notification/texting-campaign-request-notification.component';
import {
  TextingNotificationTemplateComponent,
  TextingNotificationTemplateMocks,
} from './app/templates/texting-notification/texting-notification.component';
import {
  TextingNumberDeletedTemplateComponent,
  TextingNumberDeletedTemplateMocks,
} from './app/templates/texting-number-deleted/texting-number-deleted.component';
import {
  TextingNumberDeletionScheduledTemplateComponent,
  TextingNumberDeletionScheduledTemplateMocks,
} from './app/templates/texting-number-deletion-scheduled/texting-number-deletion-scheduled.component';
import {
  VerificationCodeTemplateComponent,
  VerificationCodeTemplateMocks,
} from './app/templates/verification-code/verification-code.component';
import {
  VerificationUrlAndCodeTemplateComponent,
  VerificationUrlAndCodeTemplateMocks,
} from './app/templates/verification-url-and-code/verification-url-and-code.component';
import {
  VerificationUrlTemplateComponent,
  VerificationUrlTemplateMocks,
} from './app/templates/verification-url/verification-url.component';
import {
  WebhookDeliveryFailedTemplateComponent,
  WebhookDeliveryFailedTemplateMocks,
} from './app/templates/webhook-delivery-failed/webhook-delivery-failed.component';
import {
  WebhookPlanDowngradedTemplateComponent,
  WebhookPlanDowngradedTemplateMocks,
} from './app/templates/webhook-plan-downgraded/webhook-plan-downgraded.component';

export const TEMPLATE_ROUTES: Array<Route & { name: string; render: boolean }> = [
  ...provideTemplateDefinition('demo', DemoTemplateComponent, DemoTemplateMocks),
  ...provideTemplateDefinition(
    'account_recovery_request_started',
    AccountRecoveryRequestStartedTemplateComponent,
    AccountRecoveryRequestStartedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'account_recovery_request_url',
    AccountRecoveryRequestUrlTemplateComponent,
    AccountRecoveryRequestUrlTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'admin_deleted',
    AdminDeletedTemplateComponent,
    AdminDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'admin_deletion_request_created',
    AdminDeletionRequestCreatedTemplateComponent,
    AdminDeletionRequestCreatedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'admin_deletion_scheduled',
    AdminDeletionScheduledTemplateComponent,
    AdminDeletionScheduledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'broken_sync_alert',
    BrokenSyncAlertTemplateComponent,
    BrokenSyncAlertTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company_deleted',
    CompanyDeletedTemplateComponent,
    CompanyDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company_deletion_request_created',
    CompanyDeletionRequestCreatedTemplateComponent,
    CompanyDeletionRequestCreatedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company_deletion_scheduled',
    AdminDeletionScheduledTemplateComponent,
    CompanyDeletionScheduledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'complete_account_setup',
    CompleteAccountSetupTemplateComponent,
    CompleteAccountSetupTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'eeo_data_request',
    EeoDataRequestTemplateComponent,
    EeoDataRequestTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'email_change_start_process',
    EmailChangeStartProcessTemplateComponent,
    EmailChangeStartProcessTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'email_change_verification',
    EmailChangeVerificationTemplateComponent,
    EmailChangeVerificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'event_notification',
    EventNotificationTemplateComponent,
    EventNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'gdpr_auto_consent',
    GdprAutoConsentTemplateComponent,
    GdprAutoConsentTemplateMocks,
  ),
  ...provideTemplateDefinition('gdpr_report', GdprReportTemplateComponent, GdprReportTemplateMocks),
  ...provideTemplateDefinition(
    'inactive_admin_deleted',
    InactiveAdminDeletedTemplateComponent,
    InactiveAdminDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'inactive_company_deleted',
    InactiveAdminDeletedTemplateComponent,
    InactiveCompanyDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'join_company',
    JoinCompanyTemplateComponent,
    JoinCompanyTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'multiple_notifications',
    MultipleNotificationsTemplateComponent,
    MultipleNotificationsTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'new_candidate',
    NewCandidateTemplateComponent,
    NewCandidateTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'new_candidates_report',
    NewCandidatesReportTemplateComponent,
    NewCandidatesReportTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'notification_mention',
    NotificationMentionTemplateComponent,
    NotificationMentionTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'referral_application_confirmation',
    ReferralApplicationConfirmationTemplateComponent,
    ReferralApplicationConfirmationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'referral_email_confirmation',
    ReferralEmailConfirmationTemplateComponent,
    ReferralEmailConfirmationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'referral_send_invitation',
    ReferralSendInvitationTemplateComponent,
    ReferralSendInvitationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'requisitions_approval_request',
    RequisitionsApprovalRequestTemplateComponent,
    RequisitionsApprovalRequestTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'reset_password',
    ResetPasswordTemplateComponent,
    ResetPasswordTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'share_container',
    ShareContainerTemplateComponent,
    ShareContainerTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'sign_up_verification_reminder',
    SignUpVerificationReminderTemplateComponent,
    SignUpVerificationReminderTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'single_notification',
    SingleNotificationTemplateComponent,
    SingleNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'slots_upgraded',
    SlotsUpgradedTemplateComponent,
    SlotsUpgradedTemplateMocks,
  ),
  ...provideTemplateDefinition('sso_enabled', SsoEnabledTemplateComponent, SsoEnabledTemplateMocks),
  ...provideTemplateDefinition(
    'verification_code',
    VerificationCodeTemplateComponent,
    VerificationCodeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'verification_url',
    VerificationUrlTemplateComponent,
    VerificationUrlTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'verification_url_and_code',
    VerificationUrlAndCodeTemplateComponent,
    VerificationUrlAndCodeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'webhook_delivery_failed',
    WebhookDeliveryFailedTemplateComponent,
    WebhookDeliveryFailedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'webhook_plan_downgraded',
    WebhookPlanDowngradedTemplateComponent,
    WebhookPlanDowngradedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting_notification',
    TextingNotificationTemplateComponent,
    TextingNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting_number_deletion_scheduled',
    TextingNumberDeletionScheduledTemplateComponent,
    TextingNumberDeletionScheduledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'sign_in_detected',
    SignInDetectedTemplateComponent,
    SignInDetectedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting_campaign_request_notification',
    TextingCampaignRequestNotificationTemplateComponent,
    TextingCampaignRequestNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'feature_request_created',
    FeatureRequestCreatedTemplateComponent,
    FeatureRequestCreatedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company_verification_request',
    CompanyVerificationRequestTemplateComponent,
    CompanyVerificationRequestTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'candidate_shared',
    CandidateSharedTemplateComponent,
    CandidateSharedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'before_subscription_downgrade',
    BeforeSubscriptionDowngradeTemplateComponent,
    BeforeSubscriptionDowngradeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'after_subscription_downgrade',
    AfterSubscriptionDowngradeTemplateComponent,
    AfterSubscriptionDowngradeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'system_changed_video_provider',
    SystemChangedVideoProviderTemplateComponent,
    SystemChangedVideoProviderTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting_number_deleted',
    TextingNumberDeletedTemplateComponent,
    TextingNumberDeletedTemplateMocks,
  ),
];
